/* eslint-disable linebreak-style */
import $ from "jquery";
import datepicker from "js-datepicker";
import gsap from "gsap";
import "parsleyjs";
import intlTelInput from "intl-tel-input";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { ScrollTrigger } from "gsap/ScrollTrigger";

function init() {
  const roomForm = document.querySelector(".room-form");

  if (!roomForm) {
    return;
  }

  const roomFormWrapper = document.querySelector(".star-form-wrapper");
  const datepickerEl = document.querySelector(".start-date");
  const spinner = document.querySelector(".star-form-room-spinner");
  const success = document.querySelector(".star-form-room-response-success");
  const error = document.querySelector(".star-form-room-response-error");
  const addonInputs = document.querySelectorAll(".star-form-addon input");
  const removeAddons = document.querySelectorAll(".star-form-addon-remove");
  const step1 = document.querySelector("#star-form-step-1");
  const step2 = document.querySelector("#star-form-step-2");
  const phoneInput = document.querySelector("#phone");
  const formButton = document.querySelector(".star-form-button");
  const backButton = document.querySelector("#star-form-button-back");
  const addOnList = document.querySelectorAll(
    ".star-form-addon .star-form-addon-remove"
  );
  const roomAddonBlocks = document.querySelectorAll(".room-addon");
  const formOpen = document.querySelector(".star-form-open");
  const formClose = document.querySelector(".star-form-close");
  const addonMessages = document.querySelectorAll(".star-form-addon-message");

  let redirectLink = document.querySelector(".redirectLink");

  if (redirectLink != null) {
    redirectLink = document.querySelector(".redirectLink").textContent;
  }

  let picker = null;
  let firstStepDone = false;

  // create accouns stuff
  let theEmail = "";
  let theFirstName = "";
  let theLastName = "";

  // room stuff
  let theRoomSpaceID = "";
  let theRoomTypeID = "";
  let theRoomTypeName = "";
  let theRoomLocation = "";

  // booking stuff
  let theBookingSessionID = "";
  let theBookingSessionCost = "";
  let theBookingSessionName = "";
  let theBookingSessionCheckInDate = "";
  let theBookingSessionCheckOutDate = "";

  // money stuff
  let theTermID = 0;
  let roomPrice = 0;

  /// add on stuff
  let theAddOnList = [];

  // security stuff
  let thePostID = "";

  //address stuff
  let theMobileNumber = "";

  const termSelector = document.getElementById("check-in");

  step2.style.pointerEvents = "none";

  // on clicking term do things
  $("#check-in").on("select2:select", updateValuesOnTermSelect);

  let defaultValueRun = true;

  if (defaultValueRun == true) {
    updateValuesOnTermSelect();
    defaultValueRun = false;
  }

  function updateValuesOnTermSelect(event) {
    let num = 0;

    // on page load do the defaultValue==true// otherwise do the else
    if (defaultValueRun == true) {
      roomPrice = document.querySelector("#check-in option").value;
      let numEl = document.querySelector("#check-in option");
      num = numEl.getAttribute("data-roomselection");
    } else {
      num = this.selectedOptions[0].attributes[0].value;
      roomPrice = this.value;
    }

    // console.log(num);

    theBookingSessionCheckOutDate = document.querySelector(
      `.CheckOutDateSession${num}`
    ).textContent;
    theBookingSessionID = document.querySelector(
      `.termSessionDates${num}`
    ).textContent;
    theBookingSessionCost = parseInt(roomPrice);
    theTermID = document.querySelector(`.theTermID${num}`).textContent;
    theBookingSessionName = document.querySelector(
      ".theRoomRateName" + num
    ).textContent;

    // put in the date end.
    let dateHolder = theBookingSessionCheckOutDate.replace(/\s+/g, "");
    let date = new Date(dateHolder);
    let termEnd = String(date).split(" ", 4).join(" ");
    document.querySelector("#end-date-reminder").value = termEnd;

    /*
    console.log("Start of Setting Values On Term Select");
    console.log(`roomPrice is ${roomPrice}`);
    console.log(`Check Out Date is :${theBookingSessionCheckOutDate}`);
    console.log(`Term Session ID is :${theBookingSessionID}`);
    console.log(`Term ID is :${theTermID}`);

    console.log("Term ID is : " + theBookingSessionName);
    console.log("End of Setting Values On Term Select");
      */

    calculateTotal();
  }

  // add on stuff
  for (let i = 0; i < addOnList.length; i++) {
    theAddOnList.push(false);
  }

  // add event listeners to add ons

  for (let i = 0; i < addOnList.length; i++) {
    addOnList[i].addEventListener("click", removeAddOnArray);
    addOnList[i].myParam = addOnList[i].getAttribute("data-index");
  }

  function removeAddOnArray(evt) {
    // console.log(evt.currentTarget.myParam);

    theAddOnList[evt.currentTarget.myParam] = false;

    handleAddonEmptyMessage();
  }

  const containerFormUserDetailsTestFind =
    document.querySelector("#updateValue");

  if (containerFormUserDetailsTestFind != null) {
    updateValue.addEventListener("click", testing);
  }

  function testing(event) {
    event.preventDefault();

    const part1 = document.querySelector(".formUserDetails");
    const part2 = document.querySelector(".formRoomDetails");
    const endButton = document.querySelector(".star-form-button-wrapper");

    part1.style.display = "block";
    part2.style.display = "block";
    endButton.style.display = "block";
  }

  function starezCreateBooking() {
    const containerFormUserDetails = document.querySelector(".star-form-form");

    // add values to the form field, value
    const formdata = new FormData();

    // THESE ARE GOOD FOR TESTING WHEN STUFF BREAKS
    // default values
    // theEmail = "xpurcell@live.com";
    // theFirstName = "Xavier";
    // theLastName = "Purcell";

    // theRoomSpaceID="1380";
    // theRoomTypeID="1";
    // theRoomTypeName="Standard Room"; // pass through
    // theRoomLocation = "Kev Carmody House"
    // theBookingSessionCheckInDate="2019-02-01T00:00:00";

    // theBookingSessionID=1; //term session
    // theBookingSessionCost=500;
    // theBookingSessionCheckOutDate="2024-07-11T00:00:00";
    //  theBookingSessionName = "2022-FullYear";
    // theTermID= 1 // pulled this with cost
    // theAddOnList = [true,false,true,false,true];
    // theMobileNumber = 0449040187
    // thePostID = thePostID;

    // dynamic values
    theEmail = containerFormUserDetails.elements.email.value;
    theFirstName = containerFormUserDetails.elements["first-name"].value;
    theLastName = containerFormUserDetails.elements.surname.value;

    //theRoomSpaceID = theRoomSpaceID;
    theRoomTypeID = document.querySelector(".roomTypeID").textContent; // pass through
    theRoomTypeName = document.querySelector(".roomTypeName").textContent; // pass through
    theRoomLocation = document.querySelector(".theRoomLocation").textContent;

    //theBookingSessionCheckInDate = theBookingSessionCheckInDate; // we pull this value with datepicker

    //theBookingSessionCost = theBookingSessionCost; // pull this with cost
    //theBookingSessionName = theBookingSessionName;
    //theBookingSessionID = theBookingSessionID; // pull this with cost
    //theBookingSessionCheckOutDate = theBookingSessionCheckOutDate; // pulled this with cost

    // theTermID = theTermID; // pulled this with cost
    //theAddOnList = theAddOnList;
    thePostID = document.querySelector(".roomPostID").textContent;

    theMobileNumber = containerFormUserDetails.elements.phone.value;

    // the great add on swap

    let thePassValue = [...theAddOnList];

    /*
  // we dont need these crazy swaps right now because of updated workflow going to keep around for a little bit in case of a double back
  //thePassValue[0] = theAddOnListTemp[4];
  //thePassValue[1] = theAddOnListTemp[3]; // ad hoc cleaner = 1
  //thePassValue[2] = theAddOnListTemp[1]; // king
  //thePassValue[3] = theAddOnListTemp[0]; // queen
  //thePassValue[4] = theAddOnListTemp[2]; // kitchen
  0 : Linen & towel pack - Queen Bed
  1 : Linen & towel Pack - King Single
  2 : Kitchen Pack
  3 : All In One Pack - King Single
  4 : All in One Pack - Queen Bed
*/

    formdata.append("theEmail", theEmail);
    formdata.append("theFirstName", theFirstName);
    formdata.append("theLastName", theLastName);
    formdata.append("theRoomSpaceID", theRoomSpaceID);
    formdata.append("theRoomTypeID", theRoomTypeID);
    formdata.append("theRoomTypeName", theRoomTypeName);
    formdata.append("theRoomLocation", theRoomLocation);
    formdata.append("theBookingSessionID", theBookingSessionID);
    formdata.append("theBookingSessionName", theBookingSessionName);
    formdata.append("theBookingSessionCost", theBookingSessionCost);
    formdata.append(
      "theBookingSessionCheckInDate",
      theBookingSessionCheckInDate
    );
    formdata.append(
      "theBookingSessionCheckOutDate",
      theBookingSessionCheckOutDate
    );
    formdata.append("theTermID", theTermID);
    formdata.append("theAddOnList", thePassValue);

    formdata.append("thePostID", thePostID);

    formdata.append("theMobileNumber", theMobileNumber);

    console.log("//javascript form Data Inputs");
    console.log(theEmail);
    console.log(theFirstName);
    console.log(theLastName);
    // eslint-disable-next-line no-console
    console.log(theRoomSpaceID);
    console.log(theRoomTypeID);
    console.log(theRoomTypeName);
    console.log(theBookingSessionID);
    console.log(theBookingSessionName);
    console.log(theBookingSessionCost);
    console.log(theBookingSessionCheckInDate);
    console.log(theBookingSessionCheckOutDate);
    console.log(theTermID);
    console.log(thePassValue);
    console.log(theMobileNumber);
    console.log("end of form Data inputs//");

    let theSpinner = document.querySelectorAll(".star-form-room-spinner")[1];

    theSpinner.style.display = "flex";

    // fetch options
    const requestOptions = {
      method: "POST",
      headers: {
        // 'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: formdata,
      redirect: "follow",
      referrerPolicy: "no-referrer",
      cache: "default",
    };

    // fetch from this link. This link is defined in functions as a route from namespace + url
    fetch("/wp-json/starrezAPI/v1/bookingAPI", requestOptions)
      // get response
      .then((response) => response.text())
      // get result
      .then((result) => {
        let data = result;
        // let data = JSON.parse(result);
        //console.log(data); THIS IS FOR DEBUGGING
        theSpinner.style.display = "none";

        data = data.replace(/[\r\n]/g, "");
        if (data == "200true" || data == "404true") {
          submitErrorMessaging(
            "none",
            "none",
            "none",
            "block",
            "Success Message"
          );
          window.open(redirectLink, "_blank"); // do redirect
        } else if (data == "false" || data == "404false") {
          submitErrorMessaging(
            "none",
            "none",
            "block",
            "none",
            "Validation Error"
          );
        } else if (data == '"bookedOut"') {
          submitErrorMessaging(
            "block",
            "none",
            "none",
            "none",
            "Booked Out Error"
          );
        } else if (data == '"doubleBooking"' || data == '200"doubleBooking"') {
          submitErrorMessaging(
            "none",
            "block",
            "none",
            "none",
            "Double Booking Error"
          );
        } else {
          submitErrorMessaging(
            "none",
            "none",
            "block",
            "none",
            "If we're testing and we end up here its fine. If we are here and we're not testing trouble"
          );
        }
      })
      // catch errors
      .catch((error) => {
        submitErrorMessaging("none", "none", "block", "none", "Catch Error");
      });
  }

  function submitErrorMessaging(
    bookedOutValue,
    doubleBookingValue,
    errorValue,
    successValue,
    messageValue
  ) {
    let bookedOut = document.querySelector(".formConfirmationBookedOut");
    let doubleBooking = document.querySelector(
      ".formConfirmationAlreadyHaveABooking"
    );
    let error = document.querySelector(".formConfirmationFailure");
    let success = document.querySelector(".formConfirmation");

    console.log(messageValue);

    bookedOut.style.display = bookedOutValue;
    doubleBooking.style.display = doubleBookingValue;
    error.style.display = errorValue;
    success.style.display = successValue;
  }

  function initDatepicker() {
    const checkin = document.querySelector("#check-in");

    if (!datepickerEl || !checkin) return;

    if (picker) {
      picker.remove();
    }

    if (!checkin.options[0]) return;

    const startDate = checkin.options[checkin.selectedIndex].dataset.startdate;
    const endDate = checkin.options[checkin.selectedIndex].dataset.enddate;

    picker = datepicker(datepickerEl, {
      startDate: new Date(startDate),
      minDate: new Date(startDate),
      maxDate: new Date(endDate),
      onSelect: () => {
        const formdata = new FormData();

        let theBookingSessionCheckInDateTemp = new Date(datepickerEl.value);
        document.querySelector("#start-date-reminder").value =
          datepickerEl.value;

        // add + 10 hours to our date object to make the UTC time = our time. Javascript dates are god damn whack. See: https://stackoverflow.com/questions/7556591/is-the-javascript-date-object-always-one-day-off
        theBookingSessionCheckInDateTemp.setHours(
          theBookingSessionCheckInDateTemp.getHours() + 11
        );

        // convert to format we can use
        theBookingSessionCheckInDateTemp =
          theBookingSessionCheckInDateTemp.toISOString();

        const tempID = document.querySelector(".roomTypeID").textContent;
        const tempRoom = document.querySelector(".roomTypeName").textContent;
        const tempCampus =
          document.querySelector(".theRoomLocation").textContent;

        formdata.append("theCheckInDate", theBookingSessionCheckInDateTemp);
        formdata.append("theCheckOutDate", theBookingSessionCheckOutDate);
        formdata.append("theRoomType", tempRoom); // this will be whatever our room is on
        formdata.append("theRoomLocation", tempCampus); // whatever our campus is set to
        formdata.append("theBookingSessionID", theBookingSessionID); // whatever our campus is set to

        spinner.style.display = "flex";
        error.style.display = "none";
        success.style.display = "none";

        window.dataLayer.push({
          event: 'Custom click',
          click_category: 'UQ Res booking widget',
          click_action: 'Select item',
          click_label: datepickerEl.value,
        })

        // fetch options
        const requestOptions = {
          method: "POST",
          headers: {
            // 'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formdata,
          redirect: "follow",
          referrerPolicy: "no-referrer",
          cache: "default",
        };

        fetch("/wp-json/starrezAPI/v1/checkBookingAPI", requestOptions)
          // get response
          .then((response) => response.text())
          // get result
          .then((result) => {
            let freeRoom = result;

            //console.log("Start Date Results");
            freeRoom = freeRoom.replace(/[\r\n]/g, "");
            console.log(freeRoom);
            // console.log("End Date Results");

            if (parseInt(freeRoom) === 0) {
              returnErrorCheckerDate(
                "block",
                "none",
                "none",
                "validation error"
              );
            } else if (freeRoom == '"bookedOut"') {
              returnErrorCheckerDate(
                "block",
                "none",
                "none",
                "booked out error"
              );
            } else {
              // success
              error.style.display = "none";
              success.style.display = "block";
              spinner.style.display = "none";
              freeRoom = freeRoom.replace(/['"]+/g, "");
              theRoomSpaceID = freeRoom;
              formButton.removeAttribute("disabled");
              //console.log(`Updated theRoomSpaceID To: ${theRoomSpaceID}`);
              theBookingSessionCheckInDate = theBookingSessionCheckInDateTemp;
              /*console.log(
              `Updated theBookingSessionCheckInDate To: ${theBookingSessionCheckInDate}`
            );*/
            }
          })
          // catch errors
          .catch((error) => {
            console.log(error);
            //returnErrorChecker("block", "none", "none", "catch error");
          });
      },
    });
  }

  function returnErrorCheckerDate(
    errorValue,
    successValue,
    spinnerValue,
    errorMessage
  ) {
    error.style.display = errorValue;
    success.style.display = successValue;
    spinner.style.display = spinnerValue;
    ScrollTrigger.refresh();
    // console.log(errorMessage);
    formButton.setAttribute("disabled");
  }

  function calculateTotal() {
    const checkin = document.querySelector("#check-in");
    const finalPrice = document.querySelector("#finalPrice");
    const addons = document.querySelectorAll(
      ".formRoomDetails .star-form-addon input:checked"
    ); // just count the addOns once. (grab them from the first form part)
    let total = 0;

    total += parseFloat(checkin.options[checkin.selectedIndex].value);

    // enable this if we want addons to add to total cost.
    /*
  [...addons].forEach((addon) => {
    total += parseFloat(addon.value);
  });
  */

    finalPrice.innerHTML = `$${total.toFixed(2)}`;
  }

  function validatePhone() {
    if (!phoneInput) {
      return;
    }

    intlTelInput(phoneInput, {
      initialCountry: "auto",
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js",
      preferredCountries: ["au", "de", "us"],
      geoIpLookup(success) {
        $.get("https://ipinfo.io", () => {}, "jsonp").always((resp) => {
          const countryCode = resp && resp.country ? resp.country : "au";
          success(countryCode);
        });
      },
    });

    const phoneField = document.getElementById("phone");

    phoneField.setAttribute("placeholder", "");
  }

  function navigateTo(index) {
    window.dataLayer.push({
      event: 'Custom click',
      click_category: 'UQ Res booking widget',
      click_action: 'Link Click',
      click_label: (index - 1) === 1 ? "Continue to step 2" : "Book Now",
      click_url: index === 2 ? redirectLink : null,
    })

    roomForm.dataset.step = index;
    formButton.value = index === 1 ? "Continue to step 2" : "Book Now";
    roomFormWrapper.scrollTo({ top: 0 });
    ScrollTrigger.refresh();
  }

  function validateForms() {
    const step = parseInt(roomForm.dataset.step, 10);

    $(".star-form-form")
      .parsley()
      .whenValidate({
        group: `block-${step}`,
      })
      .done(() => {
        navigateTo(step + 1);

        if (step == 1 && firstStepDone == false) {
          firstStepDone = true;
          step2.style.pointerEvents = "all";
        }

        if (step > 1) {
          starezCreateBooking();
        }
      });
  }

  function handleAddonEmptyMessage() {
    const addons = document.querySelectorAll(".star-form-addon input");
    const messages = document.querySelectorAll(".star-form-addon-message");
    const noAddonIsChecked = [...addons].every((addon) => !addon.checked);

    [...messages].forEach((message) => {
      message.style.display = noAddonIsChecked ? "block" : "none";
    });
  }

  function toggleAddon(e) {
    const addons = document.querySelectorAll(".star-form-addon input");

    [...addons].forEach((addon) => {
      if (addon.dataset.starezIndex === e.currentTarget.dataset.index) {
        addon.checked = !addon.checked;
      }

      // check the addon in the other list
      if (e.currentTarget.dataset.starezIndex === addon.dataset.starezIndex) {
        addon.checked = !!e.currentTarget.checked;
      }
    });

    e.currentTarget.innerHTML =
      e.currentTarget.innerHTML === "+ Add" ? "- Remove" : "+ Add";

    theAddOnList[e.currentTarget.dataset.index] =
      e.currentTarget.innerHTML === "- Remove";

    handleAddonEmptyMessage();
    ScrollTrigger.refresh();
  }

  function handleRemoveAddons(e) {
    const addons = document.querySelectorAll(".star-form-addon input");

    [...addons].forEach((addon) => {
      if (addon.dataset.starezIndex === e.currentTarget.dataset.index) {
        addon.checked = "false";
      }
    });

    document.querySelector(
      `.room-addon .wp-block-button a[data-index="${e.currentTarget.dataset.index}"]`
    ).innerHTML = "+ Add";

    handleAddonEmptyMessage();
  }

  function handleMobileForm() {
    document.body.classList.toggle("is-form-open");

    if (document.body.classList.contains("is-form-open")) {
      disableBodyScroll(roomFormWrapper);
    } else {
      enableBodyScroll(roomFormWrapper);
    }
  }

  function handleAddonMessageClick() {
    const element = document.querySelector(".room-addon");
    element.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function initArrow() {
    const arrow =
      '<svg class="star-form-arrow" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="20" cy="20" r="20" fill="#2377CB"/> <path d="M21 10C21 9.44772 20.5523 9 20 9C19.4477 9 19 9.44772 19 10L21 10ZM19.2929 30.7071C19.6834 31.0976 20.3166 31.0976 20.7071 30.7071L27.0711 24.3431C27.4616 23.9526 27.4616 23.3195 27.0711 22.9289C26.6805 22.5384 26.0474 22.5384 25.6569 22.9289L20 28.5858L14.3431 22.9289C13.9526 22.5384 13.3195 22.5384 12.9289 22.9289C12.5384 23.3195 12.5384 23.9526 12.9289 24.3431L19.2929 30.7071ZM19 10L19 30L21 30L21 10L19 10Z" fill="white"/> </svg>';
    const arrowWrapper = document.createElement("div");
    arrowWrapper.classList.add("star-form-arrow-wrapper");
    arrowWrapper.innerHTML = arrow;
    roomForm.insertAdjacentElement(
      window.innerWidth < 1200 ? "beforebegin" : "beforeend",
      arrowWrapper
    );
  }

  function initScrollTrigger() {
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(".star-form-arrow", {
      scrollTrigger: {
        scroller: ".star-form-wrapper",
        trigger: ".star-form-button-wrapper",
        toggleActions: "play none none reverse",
      },
      opacity: 0,
    });
  }

  function initEvents() {
    if (roomAddonBlocks) {
      roomAddonBlocks.forEach((roomAddonBlock) => {
        roomAddonBlock
          .querySelector("a")
          .addEventListener("click", toggleAddon);
      });
    }

    removeAddons.forEach((removeAddon) => {
      removeAddon.addEventListener("click", (e) => {
        handleRemoveAddons(e);
      });
    });

    [...addonInputs].forEach((input) => {
      input.addEventListener("change", (e) => {
        toggleAddon(e);
      });
    });

    $("#check-in").on("select2:select", function (e) {
      initDatepicker();
      $("#checkin-reminder").val($.trim($(this).find(":selected").text()));
    });

    step1.addEventListener("click", () => {
      navigateTo(1);
    });

    step2.addEventListener("click", () => {
      if (firstStepDone == true) {
        navigateTo(2);
      }
    });

    backButton.addEventListener("click", () => {
      navigateTo(1);
    });

    formButton.addEventListener("click", validateForms);

    formOpen.addEventListener("click", handleMobileForm);
    formClose.addEventListener("click", handleMobileForm);

    addonMessages.forEach((addonMessage) => {
      addonMessage.addEventListener("click", handleAddonMessageClick);
    });
  }

  initEvents();
  initDatepicker();
  calculateTotal();
  initArrow();
  initScrollTrigger();
}

export default {
  init,
};
